const currencyTransformator = {
  toModelAttribute(currency) {
    if (currency == null || currency === "") {
      return null;
    }
    if (typeof currency === "number") {
      return Math.round(currency * 100);
    }

    const matchData = currency.match(/^([0-9]+)(,[0-9]{2})?$/);
    if (!matchData) {
      return null;
    }
    if (matchData[2]) {
      return parseInt(currency.replace(",", ""), 10);
    }

    return parseInt(currency, 10) * 100;
  },

  toFormAttribute(cents) {
    if (cents == null) {
      return "";
    }

    return (Math.round(parseFloat(cents, 10)) / 100)
      .toFixed(2)
      .replace(".", ",");
  },
};

export default currencyTransformator;
